import { render, staticRenderFns } from "./MasiveSectionsCharge.vue?vue&type=template&id=95e9b7aa"
import script from "./MasiveSectionsCharge.vue?vue&type=script&lang=js"
export * from "./MasiveSectionsCharge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports